import React from 'react';
import {
  View,
  TouchableOpacity,
  StyleSheet,
  Text,
  Platform,
} from 'react-native';
import { ViewPropTypes } from 'deprecated-react-native-prop-types'
import PropTypes from 'prop-types';

const HEIGHT = 35;
const COLOR = '#1FB578';
const COLOR_PASSIVE = '#F2F2F2';
// FIXME(clairbee): react-native doesn't support 'color'
// const TEXT_COLOR = 'black';
// const DISABLE_TEXT_COLOR = 'grey';

const styles = StyleSheet.create({
  crumbsContainerStyle: {
    marginHorizontal: 10,
    backgroundColor: 'transparent',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  crumbStyle: {
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    // alignSelf: 'center',
    // alignItems: 'center',
    backgroundColor: 'transparent', // COLOR_PASSIVE,
    height: HEIGHT,
  },
  activeCrumbStyle: {
    backgroundColor: COLOR,
    borderColor: COLOR,
    justifyContent: 'center',
    alignItems: 'center',
  },
  passiveCrumbStyle: {
    backgroundColor: COLOR_PASSIVE,
    borderColor: COLOR_PASSIVE,
    justifyContent: 'center',
    alignItems: 'center',
  },
  crumbTextStyle: {
    // color: COLOR,
    color: 'black',
    fontSize: 14,
    marginHorizontal: 0,
    paddingHorizontal: 0,
    textAlign: 'center',
  },
  activeCrumbTextStyle: {
    color: 'white',
    fontWeight: '600',
  },
  crumbContainer: {
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignSelf: 'center',
    alignItems: 'center',
    paddingLeft: 0, // 2? 0 is better for arrows
    marginRight: 0, // 2? 0 is better for arrows
  },
  rightTriangleContainer: {
    position: 'absolute',
    ...(Platform.OS === 'android' && ({
      top: -8.5,
    })),
    minWidth: HEIGHT / 4.0,
    width: HEIGHT / 4.0,
    right: 0,
    zIndex: 1,
  },
  leftTriangleContainer: {
    position: 'absolute',
    ...(Platform.OS === 'android' && ({
      top: -8.5,
    })),
    minWidth: HEIGHT / 4.0,
    width: HEIGHT / 4.0,
    left: 0,
    zIndex: 1,
  },
  triangleHead: {
    minWidth: HEIGHT / 4.0,
    width: HEIGHT / 4.0,
    borderTopWidth: HEIGHT / 4.0,
    borderRightWidth: 0,
    borderBottomWidth: HEIGHT / 4.0,
    borderLeftWidth: HEIGHT / 4.0,
    // borderColor: 'green',
    borderColor: COLOR,
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
  },
  triangleHeadPassive: {
    minWidth: HEIGHT / 4.0,
    width: HEIGHT / 4.0,
    borderTopWidth: HEIGHT / 4.0,
    borderRightWidth: 0,
    borderBottomWidth: HEIGHT / 4.0,
    borderLeftWidth: HEIGHT / 4.0,
    borderColor: COLOR_PASSIVE,
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
  },
  triangleTail: {
    minWidth: HEIGHT / 4.0,
    width: HEIGHT / 4.0,
    borderTopWidth: HEIGHT / 4.0,
    borderRightWidth: 0,
    borderBottomWidth: HEIGHT / 4.0,
    borderLeftWidth: HEIGHT / 4.0,
    borderColor: 'transparent',
    borderTopColor: COLOR,
    borderBottomColor: COLOR,
  },
  triangleTailPassive: {
    minWidth: HEIGHT / 4.0,
    width: HEIGHT / 4.0,
    borderTopWidth: HEIGHT / 4.0,
    borderRightWidth: 0,
    borderBottomWidth: HEIGHT / 4.0,
    borderLeftWidth: HEIGHT / 4.0,
    borderColor: 'transparent',
    borderTopColor: COLOR_PASSIVE,
    borderBottomColor: COLOR_PASSIVE,
  },
});

const Crumb = ({
  isCrumbActive,
  index,
  text,
  firstCrumbStyle,
  lastCrumbStyle,
  crumbStyle,
  activeTabStyle,
  crumbTextStyle,
  activeCrumbTextStyle,
  onCrumbPress,
  height,
  triangleHeadStyle,
  triangleTailStyle,
}) => (
  <TouchableOpacity
    style={[
      styles.crumbStyle,
      crumbStyle,
      firstCrumbStyle,
      lastCrumbStyle,
    ]}
    onPress={() => onCrumbPress(index)}
    activeOpacity={1}
  >
    {/* {Platform.OS === 'android' && !firstCrumbStyle ? <View style={{ width: height / 2.0, height, backgroundColor: 'transparent' }} /> : null} */}
    {!firstCrumbStyle && (
      <View
        style={{
          width: height / 2.5,
        }}
      />
    )}
    <View
      style={[
        styles.crumbContainer,
        isCrumbActive ? [
          styles.activeCrumbStyle, activeTabStyle,
        ] : styles.passiveCrumbStyle,
        { height },
        // {
        //   borderColor: 'blue',
        //   borderWidth: 1,
        // },
      ]}
    >
      {!firstCrumbStyle && (
        <View
          style={[
            styles.leftTriangleContainer,
            isCrumbActive ? styles.triangleTail : styles.triangleTailPassive,
            triangleTailStyle,
            { left: -height / 4 },
          ]}
        />
      )}
      <Text
        style={[
          styles.crumbTextStyle,
          crumbTextStyle,
          isCrumbActive ? [styles.activeCrumbTextStyle, activeCrumbTextStyle] : {},
          // {
          //   borderColor: 'blue',
          //   borderWidth: 1,
          // },
          { marginRight: -height / 4 },
        ]}
        numberOfLines={1}
        ellipsizeMode="tail"
      >
        {text}
        {/* {'  ' + text + ' '} */}
      </Text>
      {!lastCrumbStyle && (
        <View
          style={[
            styles.rightTriangleContainer,
            isCrumbActive ? styles.triangleHead : styles.triangleHeadPassive,
            triangleHeadStyle,
            { right: -height / 4 },
          ]}
        />
      )}
    </View>
    {/* {Platform.OS === 'android' && !lastCrumbStyle ? <View style={{ width: height / 2.0, height, backgroundColor: 'white' }} /> : null} */}
  </TouchableOpacity>
);


const handleCrumbPress = (index, flowDepth, onCrumbPress) => {
  if (flowDepth !== index) {
    onCrumbPress(index);
  }
};

Crumb.defaultProps = {
  firstCrumbStyle: undefined,
  lastCrumbStyle: undefined,
  crumbStyle: undefined,
  activeTabStyle: undefined,
  crumbTextStyle: undefined,
  activeCrumbTextStyle: undefined,
  onCrumbPress: () => { },
  triangleHeadStyle: undefined,
  triangleTailStyle: undefined,
};

Crumb.propTypes = {
  isCrumbActive: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  firstCrumbStyle: ViewPropTypes.style,
  lastCrumbStyle: ViewPropTypes.style,
  crumbStyle: ViewPropTypes.style,
  activeTabStyle: ViewPropTypes.style,
  crumbTextStyle: ViewPropTypes.style,
  activeCrumbTextStyle: ViewPropTypes.style,
  onCrumbPress: PropTypes.func,
  height: PropTypes.number.isRequired,
  triangleHeadStyle: ViewPropTypes.style,
  triangleTailStyle: ViewPropTypes.style,
};

const Breadcrumb = ({
  flowDepth,
  entities,
  borderRadius,
  crumbsContainerStyle,
  crumbStyle,
  activeCrumbStyle,
  crumbTextStyle,
  activeCrumbTextStyle,
  onCrumbPress,
  isTouchable,
  height,
}) => {
  const firstCrumbStyle = [
    { borderTopLeftRadius: borderRadius - 1, borderBottomLeftRadius: borderRadius - 1 },
  ];
  const lastCrumbStyle = [
    { borderTopRightRadius: borderRadius - 1, borderBottomRightRadius: borderRadius - 1 },
  ];
  const triangleTailStyle = height ? {
    borderTopWidth: height / 2.0, borderBottomWidth: height / 2.0, borderLeftWidth: height / 4.0,
  } : {};
  const triangleHeadStyle = height ? {
    borderTopWidth: height / 2.0, borderBottomWidth: height / 2.0, borderLeftWidth: height / 4.0,
  } : {};

  return (
    <View
      style={[
        styles.crumbsContainerStyle, borderRadius
          ? { borderRadius }
          : {}, crumbsContainerStyle,
      ]}
      removeClippedSubviews={false}
    >
      {
        entities.map((item, index) => (
          <Crumb
            key={index} // eslint-disable-line react/no-array-index-key
            index={index}
            isCrumbActive={flowDepth === index}
            text={item}
            onCrumbPress={
              isTouchable
                ? (i) => handleCrumbPress(i, flowDepth, onCrumbPress)
                : () => { }
            }
            firstCrumbStyle={index === 0 ? firstCrumbStyle : null}
            lastCrumbStyle={index === entities.length - 1 ? lastCrumbStyle : null}
            crumbStyle={crumbStyle}
            activeCrumbStyle={activeCrumbStyle}
            crumbTextStyle={[
              crumbTextStyle,
              // FIXME(clairbee): react-native doesn't support 'color'
              // index < flowDepth
              //   ? { color: TEXT_COLOR }
              //   : { color: DISABLE_TEXT_COLOR },
            ]}
            activeCrumbTextStyle={activeCrumbTextStyle}
            height={height || HEIGHT}
            triangleTailStyle={triangleTailStyle}
            triangleHeadStyle={triangleHeadStyle}
          />
        ))
      }
    </View>
  );
};

Breadcrumb.defaultProps = {
  borderRadius: 0,
  onCrumbPress: () => { },
  crumbsContainerStyle: undefined,
  crumbStyle: undefined,
  activeCrumbStyle: undefined,
  crumbTextStyle: undefined,
  activeCrumbTextStyle: undefined,
  height: HEIGHT,
};

Breadcrumb.propTypes = {
  entities: PropTypes.array.isRequired, // eslint-disable-line
  flowDepth: PropTypes.number.isRequired,
  isTouchable: PropTypes.bool.isRequired,
  onCrumbPress: PropTypes.func,
  crumbsContainerStyle: ViewPropTypes.style,
  borderRadius: PropTypes.number,
  crumbStyle: ViewPropTypes.style,
  activeCrumbStyle: ViewPropTypes.style,
  crumbTextStyle: PropTypes.object, // Text.propTypes.style,
  activeCrumbTextStyle: PropTypes.object, // Text.propTypes.style,
  height: PropTypes.number,
};

export default Breadcrumb;
